import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private applicationInsightsService: ApplicationInsightsService) {}

  handleError(error: Error): void {
    // Log to Application Insights
    this.applicationInsightsService.trackException(error);
    
    // Also log to console for development
    console.error('Global error handler:', error);
  }
}